export default __webpack_public_path__ + "static/media/boatwater.4439697b.gif";